export const WATERMARK_POSITIONS = [
  { value: 'center', label: 'Centro' },
  { value: 'top-left', label: 'Arriba a la izquierda' },
  { value: 'top-right', label: 'Arriba a la derecha' },
  { value: 'bottom-left', label: 'Abajo a la izquierda' },
  { value: 'bottom-right', label: 'Abajo a la derecha' },
] as const;

export type ProductWatermarkPosition = (typeof WATERMARK_POSITIONS)[number]['value'];

export const DEFAULT_WATERMARK_OPACITY = 35;
export const DEFAULT_WATERMARK_SIZE = 42;
export const DEFAULT_WATERMARK_POSITION: ProductWatermarkPosition = 'center';

const clamp = (value: number, min: number, max: number): number => Math.min(max, Math.max(min, value));

const readNumber = (value: unknown): number | null => {
  if (value == null || value === '') return null;
  const parsed = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export const clampWatermarkOpacity = (value: unknown): number => {
  const parsed = readNumber(value);
  if (parsed == null) return DEFAULT_WATERMARK_OPACITY;
  return clamp(Math.round(parsed), 5, 100);
};

export const clampWatermarkSize = (value: unknown): number => {
  const parsed = readNumber(value);
  if (parsed == null) return DEFAULT_WATERMARK_SIZE;
  return clamp(Math.round(parsed), 15, 80);
};

export const normalizeWatermarkPosition = (value: unknown): ProductWatermarkPosition => {
  const found = WATERMARK_POSITIONS.find((item) => item.value === value);
  return found?.value ?? DEFAULT_WATERMARK_POSITION;
};

/** Solo las fotos propias del producto llevan marca. El reemplazo "sin foto" no. */
export const hasProductPhoto = (imageUrl?: string | null): boolean => Boolean(imageUrl?.trim());
